<template>
  <transition name="scroll-to-bottom-fade">
    <div 
      class="vue-scroll-to-bottom" 
      :style="`top:${this.top};right:${this.right};`" 
      v-show="visible" 
      @click="backToTop">
      <slot>
        <div class="default">
          <span>
            {{ text }}
          </span>
        </div>
      </slot>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'ScrollToBottom',
  props: {
    text: {
      type: String,
      default: 'Aller à la fin',
    },
    visibleoffset: {
      type: [String, Number],
      default: 0,
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 600,
    },
    right: {
      type: String,
      default: '30px',
    },
    top: {
      type: String,
      default: '40px',
    },
    scrollDownFn: {
      type: Function,
      default: function (eventObject) {},
    }
  },
  data () {
    return {
      visible: true
    }
  },
  mounted () {
    window.smoothscrollDown = () => {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      let height = document.body.scrollHeight
      console.log('height',height)
      if (height > currentScroll) {
        // window.requestAnimationFrame(window.smoothscrollDown)
        // window.scrollTo(0, Math.floor(currentScroll + (height / 10)))
        window.scrollTo(0, height)
      }
    }
    window.addEventListener('scroll', this.catchScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.catchScroll)
  },
  methods: {
    /**
     * Catch window scroll event 
     * @return {void}
     */
    catchScroll () {
      const pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset)
      const pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - parseInt(this.visibleoffsetbottom)
      this.visible = !pastTopOffset
      this.scrollDownFn(this)
    },
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop () {
      window.smoothscrollDown()
      this.$emit('scrolled')
    }
  },
}
</script>
<style>
  .vue-scroll-to-bottom-fade-enter-active, 
  .vue-scroll-to-bottom-fade-leave-active {
    transition: opacity .7s;
  }
  .vue-scroll-to-bottom-fade-enter, 
  .vue-scroll-to-bottom-fade-leave-to {
    opacity: 0;
  }

  .vue-scroll-to-bottom {
    cursor:pointer;
    position: fixed;
    z-index: 1000;
  }

  .vue-scroll-to-bottom .default {
    background-color: #f5c85c;
    border-radius: 3px;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    text-align: center;
    width: 160px;
  }

  .vue-scroll-to-bottom .default span{
    color:#ffffff;
  }

  .vue-scroll-to-bottom--is-footer {
    bottom: 50% !important;
    position: absolute;
    transform: translateY(50%);
  }
</style>
